import Vue from "vue";
import axios from "axios";

axios.defaults.headers["Content-Type"] = "application/json";
const token = localStorage.getItem("token");

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios.create({
      baseURL: process.env.NODE_ENV === "production"
        ? "https://api-csidev.blackredsistemas.com.br"
        : "http://localhost:3000/",
      headers: { Authorization: `Bearer ${token}` },
    });
  },
});
